// notice: must use compiled file for user agent may only support es5 feature.
var isBrowser = typeof window !== 'undefined';
var KNB = isBrowser ? require('./compiled/interface') : {load: function(){}, _ready: function(){}};
if (isBrowser) window.KNB = KNB;

var KNBExtend = (function () {
  if (typeof window === 'undefined') return; // do not load KNB if not run in browser
  var env = require('./env');
  switch (true) {
    case env.isDPApp:
      return require('./compiled/dpapp');
    case env.isMTNB:
      return require('./compiled/mtnb');
    case env.isHBNB:
      return require('./compiled/hbnb');
    case env.isTitans:
      return require('./compiled/titans');
    case env.isWX:
      if (typeof _KNB_IGNORE_WECHAT !== 'undefined') return; // 如果用户有配置这个变量，则跳过对微信的适配
      return require('./compiled/wx');
  }
})();

KNB.load(KNBExtend || {});
KNB._ready();

module.exports = KNB;



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/index.js
// module id = 282
// module chunks = 1 12 14